/**
 * Shared regex patterns for form validation.
 * Patterns are defined without the global flag (`g`) for correct behavior with .test() in validators.
 */

/** Email validation. Allows `+` in the local part for aliases (e.g. user+tag@domain.com). */
export const EMAIL_PATTERN =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
